import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProdukPage from "./LandingPage/Pages/produk/produkPages";

// Import halaman
import LandingPage from "./LandingPage/Pages";
import NewsDetailPage from "./LandingPage/Pages/news/detailNews";
import DonasiUmumPage from "./LandingPage/Pages/donasiUmum/donasiUmumPage";
import MapsPage from "./LandingPage/Pages/MapsPages/page";
import PagesPendaftaran from "./LandingPage/Pages/pendaftaran/pages";
import DetailKonsenPages from "./LandingPage/Pages/konsentrasi/detailKonsenPages";
import KonsenPages from "./LandingPage/Pages/konsentrasi/konsenPages";
import PageDetailFokus from "./LandingPage/Pages/fokus/pageDetailFouks";

const App: React.FC = () => {
  return (
    <Router>
      <div className="font-montserrat">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="news/detail/:id" element={<NewsDetailPage />} />
          <Route path="produk" element={<ProdukPage />} />
          <Route path="donasiumum" element={<DonasiUmumPage />} />
          <Route path="regioncheck" element={<MapsPage />} />
          <Route path="pendaftaran" element={<PagesPendaftaran />} />
          <Route path="/program/:slug" element={<DetailKonsenPages />} />
          <Route path="/program" element={<KonsenPages />} />
          <Route path="/fokus/:slug" element={<PageDetailFokus />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
